import { sleep } from './sleep';

export const retryWithExponentialBackoff = async <T>(
  fn: () => Promise<T>,
  retries: number,
  baseDelay: number,
  maxDelay?: number,
  attempt = 1,
): Promise<T> => {
  try {
    return await fn();
  } catch (error) {
    if (attempt > retries) {
      throw error;
    }
    const delay = maxDelay
      ? Math.min(baseDelay * 2 ** attempt, maxDelay)
      : baseDelay * 2 ** attempt;
    await sleep(delay);
    return retryWithExponentialBackoff(fn, retries, baseDelay, maxDelay, attempt + 1);
  }
};
